// extracted by mini-css-extract-plugin
export default {"container":"xPLDyv","price":"OBtszx","content":"LoLiNH","loading":"D0k4CY","priceDiff":"HMwxq2","priceDiff__row":"DOAhc8","priceDiff__result":"YILACk DOAhc8"};